import compose from "recompose/compose";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import getCountryName from "./getCountryName";

const byLabel = ({ label: labelA }, { label: labelB }) => {
  return labelA.localeCompare(labelB);
};

/**
 * @typedef {Object} WithCountriesGraphQLPropsOptions
 * @property {Object} data
 * @property {Object} ownProps
 */

/**
 * @typedef {Object} WithCountriesGraphQLExtraProps
 * @property {[{ value: string, label: string }]} countries
 */

/**
 * @callback WithCountriesGraphQLPropsCallback
 * @param {WithCountriesGraphQLPropsOptions} param0
 * @returns {WithCountriesGraphQLExtraProps}
 */

/**
 * @param {{ CountriesQuery: import('graphql').DocumentNode }} props
 */
const withCountries = ({ CountriesQuery }) =>
  compose(
    injectIntl,
    graphql(CountriesQuery, {
      props: /** @type {WithCountriesGraphQLPropsCallback} */ ({
        data,
        ownProps: { intl },
      }) => {
        return {
          countries: data.loading
            ? []
            : data.countryList
                .map((country) => ({
                  value: country,
                  label: getCountryName(intl, country),
                }))
                .sort(byLabel),
        };
      },
    })
  );

export default withCountries;
